<template>
  <div class='qrcode-modal'>
    <mt-popup v-model="bshow"
              class='guestInfo-delay'
              popup-transition="popup-fade">
      <div class='delayIn-main'>
        <div class="main" ref="poster">
          <h2>{{ $t('scanPay_title') }}</h2>
          <div class="guestSwiper">
            <div class="line">
              <p>{{ $t('hotelName') }}：{{hotelName}}</p>
            </div>
            <div class="line">
              <p>{{ $t('fangTXQ_bookName') }}：{{name}}</p>
            </div>
            <div class="line">
              <p>{{ $t('fangTXQ_bookTime') }}：{{arr}}</p>
            </div>
            <div id="qrCode" class="qrCode" ref="qrCodeDiv">
              <img :src="qrCodeSrc" />
            </div>
            <div class="line">
              <p>{{ $t('fangTXQ_transactionAmount') }}：{{price}}</p>
            </div>
          </div>
        </div>

        <div class="btn">
          <div class="unSure"
                @click="onExport('download')">{{ $t('fangTXQ_savePictrue') }}
          </div>
          <div v-if="!isIos" class="sure" @click="onExport('share')">{{ $t('fangTXQ_forwardWechat') }}
          </div>
        </div>
      </div>

    </mt-popup>
  </div>
</template>
<script>
import html2canvas from "html2canvas";
import { Toast,Indicator } from "mint-ui";

export default {
  data() {
    return {
      bshow: false,
      sharewx: null,
      name:"",
      arr:"",
      hotelName:"",
      qrCodeSrc:"",
      price:"",
      isShare:false,
      isIos: false
    };
  },
  props: {},
  mounted() {
    this.isIos = this.isIosOrAndroid() == 2
  },
  methods: {
    show(data) {
      this.bshow = true;
      let {name, arr, src, price} = data;
      this.name = name;
      this.arr = arr;
      this.price = price;
      this.hotelName =  localStorage.getItem("switchHotelInfo") ? JSON.parse(localStorage.getItem("switchHotelInfo")).hotelName : localStorage.getItem("homeUserInfo") ? JSON.parse(localStorage.getItem("homeUserInfo")).hotelName : "";
      this.qrCodeSrc = src;
    },
    disCodeName(v) {
      return v.code + ' -- ' + v.name;
    },
    // <!--导出海报事件-->
    onExport(type) {
      var scale = 2; //放大倍数（增加导出海报的清晰度）
      html2canvas(this.$refs.poster, {
        dpi: window.devicePixelRatio * 2,
        scale: scale,
        allowTaint: true
      }).then((canvas) => {
        let dataURL = canvas.toDataURL("image/png");
        this.downloadOrShareImage(dataURL, "分享图片", type);
      });
    },
    // 图片下载函数
    downloadOrShareImage(imgsrc, name, type) {
      let self = this;
      //下载图片地址和图片名
      let image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        let context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);

        var dataUrl = canvas.toDataURL();
        self.bitmapSavePic(dataUrl,type);
      };
      image.src = imgsrc;
    },

    getsend(msg) {
      this.sharewx.send(msg, () => {
        this.msg('分享成功');
      }, (error) => {
        this.msg('分享失败,请重新分享,' + JSON.stringify(error));
      })
    },
    msg(msg) {
      Toast({message: msg, position: "bottom", duration: 3000});
    },

    bitmapSavePic(src,type) {
      let self = this;
      var bmloadSuccessCB = function (e) {
        console.log("加载base64数据成功")
      }
      var bmloadErrorCB = function (err) {
        console.log("加载base64数据失败")
        console.log(err)
      }
      var bmSaveSuccessCB = function (e) {
        console.log(e)
        console.log("保存成功")
        console.log("保存地址：" + e.target)
        saveToGallery(e.target)
      }
      var bmSaveErrorCB = function (error) {
        plus.nativeUI.toast("保存失败")
        console.log("code：" + error.code + ";msg:" + error.message);
      }

      var saveToGallery = function (path) {
        console.log(path)
        plus.gallery.save(path, function (e) {
          plus.nativeUI.toast('保存到相册成功')
          if(self.isShare){//分享
            let msg = {
              type: "image",
              pictures: [path],
              extra: {
                scene: 'WXSceneSession'
              }
            }
            plus.share.getServices(function (e) {
              //在这个数组里 找到属于微信的对象 循环匹配查找
              for (var i in e) {
                if ('weixin' == e[i].id) {
                  self.sharewx = e[i] //保存到变量里 （之后即可使用该对象发起分享）
                  if(_isIosOrAndroid == 1){
                    msg.webUrl = 'https://m.ihotel.cn/'
                  }
                  self.getsend(msg)
                }
              }
            })
          }
        }, function (err) {
          plus.nativeUI.toast('保存到相册失败, ' +err.message)
        });
      }

      var bm = new plus.nativeObj.Bitmap("test")//path: ( String ) 可选 Bitmap对象自动加载图片的地址
      bm.loadBase64Data(src, bmloadSuccessCB, bmloadErrorCB);//加载base64为数据到bm实例对象
      let _isIosOrAndroid = this.isIosOrAndroid();
      if(_isIosOrAndroid == 1){
        var path = `file:///storage/emulated/0/Documents/qrcode.jpg`
      }else if(_isIosOrAndroid == 2){
        var path = `_doc/qrcode.jpg`
      }
      var options = {"overwrite": true, "format": "jpg", "quality": 50}
      if(type == 'share'){
        self.isShare = true;
      }else{
        self.isShare = false;
      }
      bm.save(path, options, bmSaveSuccessCB, bmSaveErrorCB);//将图片保存到指定的路径（仅支持本地文件系统）
      //保存到相册后，回收Bitmap图片内存
      setTimeout(() => {
        bm.recycle();
      }, 1000)
    },
    //判断安卓端还是ios端
    isIosOrAndroid() {
        var u = navigator.userAgent
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
        if (isAndroid) {
            return 1
        }
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isiOS) {
            return 2
        }
        return 0
    },
  },
};
</script>

<style lang='less' scoped>
.qrcode-modal {

  .guestInfo-delay {
    width: 100%;
    position: absolute;
    margin: 0 auto;
    padding: 0 15px;
    box-sizing: border-box;
    background: none;

    .delayIn-main {
      background: #fff;
      width: 100%;
      margin: 0 auto;
      box-sizing: border-box;
      border-radius: 10px;
      .main{
        background: #fff;
        width: 100%;
        margin: 0 auto;
        box-sizing: border-box;
        border-radius: 10px;
      }
    }

    h2 {
      font-size: 18px;
      color: #666666;
      text-align: center;
      font-style: normal;
      padding: 15px 0;
    }

    .mint-cell-title {
      width: 80px;
    }

    .guestSwiper {
      padding: 0.5rem;
      .line {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        p {
          font-size: 15px;
          flex: 1;
          margin: 0.1rem 0;
          text-align: center;
        }

        .date-picker {
          .input-wrapper {
            width: 4.2rem;
          }

          .dinp {
            padding-left: 0;
          }
        }

        .inputNumber {
          width: 4.2rem;
          box-sizing: border-box;
          overflow: hidden;
          border-color: #cccccc;

          .el-p, .el-j {
            border-color: #cccccc;
          }
        }
      }

      .qrCode {
        margin: 0.2rem 0;
        /deep/ img {
          width: 100% !important;
        }
        /deep/ canvas {
          width: 100% !important;
        }
      }

    }

    .btn {
      height: 55px;
      border-top: 1px solid #bdbdbd;
      text-align: center;
      font-size: 16px;
      width: 100%;
      display: flex;

      .unSure {
        flex: 1;
        box-sizing: border-box;
        line-height: 55px;
      }

      .sure {
        flex: 1;
        border-left: 1px solid #bdbdbd;
        box-sizing: border-box;
        line-height: 55px;
        color: #5190c3;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// qrcodeModal.vue?4dce0760